<template>
  <div
    class="CitasCalendario"
    style="margin-top:8px!important"
  >
    <md-button
      v-if="usuarios.length >1"
      class="md-fab md-fixed md-dense md-fab-top-right"
      @click="showDialogFiltroUsuarios = true"
    >
      <md-tooltip>Filtrar por usuario</md-tooltip>
      <md-icon>account_circle</md-icon>
    </md-button>

    <vue-cal
      style="min-height:80vh;"
      :events="citas"
      :disable-views="['years','year']"
      locale="es"
      :time="false"
      default-view="month"
      events-on-month-view="short"
      :show-week-numbers="false"
      :on-event-click="onEventClick"
      @ready="_obtenerCitasAdministrador"
      @view-change="_obtenerCitasAdministrador"
    />
    <md-dialog :md-active.sync="showDialogFiltroUsuarios">
      <md-dialog-title>Filtrar citas por usuario</md-dialog-title>
      <md-dialog-content>
        <md-field>
          <label>Seleccione un usuario</label>
          <md-select
            md-dense
            v-model="usuarioSeleccionado"
          >
            <md-option
              v-for="u in usuarios"
              :key="u.id"
              :value="u.id"
            >{{u.nombre_usr + ' ' +u.ap_pat_usr + ' '+u.ap_mat_usr}}</md-option>
          </md-select>
        </md-field>
        <md-button
          v-if="usuarioSeleccionado"
          @click="usuarioSeleccionado = '';_aplicarFiltroUsuario()"
        >Borrar filtros</md-button>
      </md-dialog-content>
      <md-dialog-actions>
        <md-button @click="showDialogFiltroUsuarios=false">Cerrar</md-button>
        <md-button
          @click="_aplicarFiltroUsuario"
          v-if="usuarioSeleccionado"
          class="md-raised md-primary"
        >Filtrar</md-button>
      </md-dialog-actions>
    </md-dialog>
  </div>
</template>

<script>
import falloResponse from "@/mixins/falloResponse.js";
import usuariosObtener from "@/mixins/usuariosObtener.js";
import VueCal from "vue-cal";
import "vue-cal/dist/i18n/es.js";
import "vue-cal/dist/vuecal.css";

export default {
  name: "CitasCalendario",
  mixins: [falloResponse, usuariosObtener],
  components: { VueCal },
  methods: {
    onEventClick(a) {
      this.$router.push("/escuela/" + a.id_esc_cit);
    },
    _preObtenerCitas(a) {
      let tipo = this.$session.get("tipo");
      tipo && tipo != "medico"
        ? this._obtenerCitasAdministrador()
        : this._obtenerCitasMedico();
    },
    _obtenerCitasAdministrador(a) {
      if (a && this.$session.get("tipo") != "medico") {
        this._obtenerUsuarios();
        this.aaa = a;
        let aa = this.$moment(a.startDate).format("YYYY-MM-DD");
        let bb = this.$moment(a.endDate).format("YYYY-MM-DD");
        this.cargando = true;
        this.$http
          .get(
            "citas?a=" + aa + "&b=" + bb + this.filtroUsrSelect,
            this.$headers
          )
          .then(
            res => {
              this.cargando = false;
              if (res.status === 401) {
                this.$router.push("/login");
              } else if (res.status === 200 && "citas" in res.body) {
                this.citas = res.body.citas;
              } else {
                this._falloResponse(res);
              }
            },
            err => this._falloResponse(err)
          );
      }
    },
    _obtenerCitasMedico() {
      this.flagCitasMedicoObtenidas = true;
      JSON.parse(localStorage.getItem("escuelas_citas")).forEach(escuela => {
        if (escuela.escuelas_citas.length >= 1) {
          escuela.escuelas_citas.forEach(cita_esc => {
            this.citas.push(cita_esc);
          });
        }
      });
    },
    _aplicarFiltroUsuario() {
      this.showDialogFiltroUsuarios = false;
      this.filtroUsrSelect = "&medico=" + this.usuarioSeleccionado;
      console.log(this.filtroUsrSelect);
      this._obtenerCitasAdministrador(this.aaa);
    }
  },
  data() {
    return {
      aaa: Object, //recodatorio de la fecha en que esta el calendario
      usuarios: [],
      showDialogFiltroUsuarios: false,
      usuarioSeleccionado: false,
      filtroUsrSelect: "",
      flagCitasMedicoObtenidas: false, //bandera para en caso que cambie de mes, no recargar todo
      cargando: false,
      cita: {
        id: null,
        id_cit: null,
        id_esc_cit: null,
        fecha_cit: null,
        hora_cit: null,
        estatus_cit: null
      },
      citas: [],
      escuela: "",
      escuelas: [],
      usuarios: [],
      errores: {
        id: null,
        id_cit: null,
        id_esc_cit: null,
        fecha_cit: null,
        hora_cit: null,
        estatus_cit: null
      }
    };
  },
  watch: {},
  created() {
    this._preObtenerCitas();
  },
  beforeCreate() {
    if (!this.$session.exists() && !this.$session.get("tipo")) {
      this.$emit("visible", false);
      this.$router.push("/login");
    } else {
      this.$emit("visible", true);
      this.$emit("classes", "container");
    }
  }
};
</script>
